import { Form } from 'antd';
import { GetProps, Col, GetProp } from 'antd';

export type IColProps = GetProps<typeof Col>;
export type IRules = GetProp<typeof Form.Item, 'rules'>;

export enum ValidateStatus {
	success = 'success',
	warning = 'warning',
	error = 'error',
	validating = 'validating'
}
export interface IFormItemProps {
	itemkey?: string;
	label?: React.ReactNode;
	help?: React.ReactNode;
	required?: boolean;
	validateStatus?: ValidateStatus;
	prefixCls?: string;
	className?: string;
	labelCol?: IColProps;
	wrapperCol?: IColProps;
	extra?: React.ReactNode;
	hasFeedback?: boolean;
	style?: React.CSSProperties;
	colon?: boolean;
	labelAlign?: 'left' | 'right';
	name?: string;
	rules?: IRules;
	getValueFromEvent?: (...args: any) => any;
	children?: React.ReactNode;
	seleniumId?: string;
	noStyle?: boolean;
	shouldUpdate?: any;
	initialValue?: any;
	dependencies?: any[];
}
